<template>
  <div>
    <v-btn class="btnDetails" icon x-large dark text style="margin-left:1vh;" @click="openDialog">
      <v-icon color="primary">mdi-pencil</v-icon>
    </v-btn>

      <v-dialog v-model="dialog" transition="dialog-bottom-transition" max-width="600" persistent>
        <template>
          <v-card class="container justify-content-between align-items-center">
            <button class="close-button" @click="closeDialog()">
              <span class="small-x">X</span>
            </button>
            <v-col cols="12" md="12" sm="6">
              <img alt="logoIbliss" src="https://ibliss-icons-prod.s3.us-east-1.amazonaws.com/marca_empresarial/image-welcomeDefault.png" class="custom-img" />
            </v-col>
            <h2 class="custom-title">{{ $t('reconciliation.label.title') }}</h2>

            <div v-if="loading" class="text-center">
              <v-progress-circular
                  class="mt-auto"
                  :size="70"
                  :width="7"
                  color="primary"
                  indeterminate
              ></v-progress-circular>
            </div>
            <div v-else>
              <formChangeStarZen :starZenForm ="this.starZen"/>
            </div>
          </v-card>
        </template>
      </v-dialog>
    </div>
</template>

<script>

import formChangeStarZen from "@/views/star_assignment/star_assignment_zen/components/form_change_star_component.vue";
import { mapGetters } from "vuex";

import {

  STARASSIGNMENT_M,
  GET_STATE_LOADING_STARASSIGNMENT

} from "@/views/star_assignment/store/types/types.js";

export default {
  name: "ChangeStarZen",
  components: {
    formChangeStarZen
  },
  props: {
    starZen: {
      required: false,
      default: null,
    },

  },
  data() {
    return {
      dialog: false,
    };
  },
  methods: {

    async mounted() {
    },
   
    openDialog() {
        this.dialog = true;
    },
    closeDialog() {
        this.dialog = false;
        window.location.reload();
      },
  },

  computed: {
    ...mapGetters({ 
    loading: `${STARASSIGNMENT_M}${GET_STATE_LOADING_STARASSIGNMENT}`,
  }),
  },

};
</script>

<style lang="css" scoped>

  body {
      font-family: "Nunito Sans", sans-serif;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
      font-family: "Amsi Pro", sans-serif;
  }

  .small-x {
  font-size: smaller;
  }

  .close-button {
      position: absolute;
      top: 5px;
      right: 10px;
      background: none;
      border: none;
      cursor: pointer;
  }

  .custom-img {
      width: 170px;
      height: auto;
      display: block;
      margin: 0 auto;
  }

  .custom-title {
      color: #6e17a5;
      justify-items: center;
  }

  .custom-text {
      font-size: 16px;
      color: #000000;
      text-align: center;
      margin: 5px;
  }

  .nombre {
      font-size: 14px;
      color: #414141;
  }

  .container {
      display: flex;
      flex-direction: column;
      align-items: center;
      font-size: 3vh;
      color: #6e17a5;
  }

  .v-btn {
      display: flex;
      align-items: center;
      justify-content: center;
  }

  @media screen and (max-width: 900px) {
      .row {
          padding-top: 0vh;
      }

      .custom-img {
          width: 100px;
      }

      .custom-title {
          color: #6e17a5;
          justify-items: center;
          font-size: 28px;
      }
  }

</style>
